export default "__VITE_ASSET__DAW24SAW__"